import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Url extends PureComponent {
  render() {
    return (
      <div className="row" id="url">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Get my API URL</h2>
              <p>
                Before you start, you will need your Nexoid API URL and the
                Customer ID connected to your account. Nexoid API URLs are made
                up of the region prefix and the cluster number. When you create
                a Nexoid account, the sign-up process asks you to select a
                region. All record data, file attachments, workflow processing
                and audit logs are kept within that geographic region. Once a
                customer has been created the Customer ID, and API region
                cluster cannot be changed.
              </p>
              <p>
                To get your Customer ID and API URL, you will need to know your
                customer name. Your customer name is the name your user's type
                before logging in or is the end of your unique sign-in URL.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Get my API URL</h2>
            </section>

            <section>
              <h3>Customer Find</h3>
              <p>
                To get your customer ID and API URL, use a GET request to the
                URL below noting to change your customer name at the end. This
                example is searching for the fictional company "ACME".
              </p>
              <p>
                The "Customer Find" response contains the Customer ID, API URL,
                the customer name with formating and the customer log in, which
                identifis the customer.
              </p>
              <p>
                Note that in this example, we are using the Master API URL
                (api.nexoid.com) to find your customer-specific URL (in this
                example au43.api.nexoid.com).
              </p>
              <p>URL:</p>
              <div className="darkCode">
                <span className="methodCodeGET">GET</span> - https://
                <strong>api.nexoid.com</strong>/v1/customer/find/
                <strong>
                  <span className="jsonY">acme</span>
                </strong>
              </div>
              <p>Example Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"id"</span>:{" "}
                  <span className="jsonY">"5346"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"customer"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"login"</span>:{" "}
                  <span className="jsonY">"acme"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"ACME"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"api_url"</span>:{" "}
                  <span className="jsonY">"au43.api.nexoid.com"</span>
                </div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
              <p>
                This response has returned the Customer ID <strong>5346</strong>{" "}
                and the Customer URL <strong>au43.api.nexoid.com</strong>.
              </p>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Url;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Url.js